module.exports = __webpack_public_path__ + "img/11-Kiosk-(Shop)-min.e12c08cb.png";